// Textos cortos que se repiten en varias pantallas.
import { DIA_SEMANA_ETIQUETA, diaSemana, formatoFecha, hoyISO, sumarDias } from '@reparto/shared/nucleo';
import type { ClienteRuta } from '../datos/tipos';

/** 135 → "2 h 15 min" */
export function duracion(min: number | null | undefined): string {
  if (min == null) return '—';
  const m = Math.max(0, Math.round(min));
  if (m < 60) return `${m} min`;
  return `${Math.floor(m / 60)} h${m % 60 ? ` ${m % 60} min` : ''}`;
}

/** "08:00 a 12:00", "desde 14:00", "hasta 10:30" o null. */
export function ventana(desde: string | null, hasta: string | null): string | null {
  const d = desde?.slice(0, 5);
  const h = hasta?.slice(0, 5);
  if (d && h) return `${d} a ${h}`;
  if (d) return `desde ${d}`;
  if (h) return `hasta ${h}`;
  return null;
}

export const km = (n: number | null | undefined) =>
  n == null ? '—' : `${n.toLocaleString('es-PY', { maximumFractionDigits: 1 })} km`;

/** Estado de la ubicación del cliente para avisar al chofer. */
export function ubicacionCliente(c: ClienteRuta): 'verificada' | 'aproximada' | 'sin' {
  if (c.ubicacion && c.ubicacion_verificada) return 'verificada';
  if (c.ubicacion || c.ubicacion_aproximada) return 'aproximada';
  return 'sin';
}

/** "mañana jueves 23/10", "el viernes 24/10": para decir para cuándo es una carga que no es la de hoy. */
export function diaDeCarga(fecha: string, hoy = hoyISO()): string {
  const dia = DIA_SEMANA_ETIQUETA[diaSemana(fecha)].toLowerCase();
  const corta = formatoFecha(fecha).slice(0, 5);
  return fecha === sumarDias(hoy, 1) ? `mañana ${dia} ${corta}` : `el ${dia} ${corta}`;
}
